import React from 'react';
import pinColor from '../../Images/pin-clr.svg';
import pinWhite from '../../Images/pin-01.svg';
import {
  formatFirstCommunication,
  formatLastCommunication,
} from './summaryFormatUtils';
import { getAssetStatusClassName } from './summaryDisplayUtils';
import SummaryAlertsCell from './SummaryAlertsCell';

type AssetRow = Record<string, any>;

type Props = {
  row: AssetRow;
  rowIndex: number;
  variant: 'assets' | 'pinned';
  pinningAssetId: string | null;
  isPinnedInMap: boolean;
  onPinClick: (row: AssetRow) => void;
  onAssetNameClick: (row: AssetRow) => void;
  onGatewayStatusClick: (row: AssetRow) => void;
  onAlertsClick: (row: AssetRow) => void;
};

const SummaryTableRow: React.FC<Props> = ({
  row,
  rowIndex,
  variant,
  pinningAssetId,
  isPinnedInMap,
  onPinClick,
  onAssetNameClick,
  onGatewayStatusClick,
  onAlertsClick,
}) => {
  const pinBackground = variant === 'pinned' || isPinnedInMap ? pinColor : pinWhite;
  const pinCellStyle =
    variant === 'pinned'
      ? { background: '#0F1D2E', zIndex: '10' }
      : { zIndex: '5', backgroundColor: '#101c2b' };
  const nameCellBg = variant === 'pinned' ? '#0F1D2E' : '#101c2b';
  const gatewayLabel = variant === 'assets' ? 'Device Status' : 'Gateway Status';

  return (
    <tr>
      <td className={variant === 'pinned' ? 'summary-pin' : 'summary-pin'} style={pinCellStyle}>
        <span
          className="summary-pin-icon"
          style={{
            backgroundImage: `url(${pinBackground})`,
            cursor: pinningAssetId === row.assetId ? 'wait' : 'pointer',
          }}
          onClick={() => onPinClick(row)}
        />
      </td>
      <td
        className="asset-link"
        onClick={() => onAssetNameClick(row)}
        style={{ cursor: 'pointer', backgroundColor: nameCellBg }}
        title={row.assetName || ''}
      >
        {row.assetName || ''}
      </td>
      <td className="text-wrap-customer" title={row.customerName || ''}>{row.customerName || ''}</td>
      <td className="text-wrap-site" title={row.siteName || ''}>{row.siteName || ''}</td>
      <td className="text-wrap-plant" title={row.plantName || ''}>{row.plantName || ''}</td>
      <td className="text-wrap-assettype" title={row.assetType || ''}>{row.assetType || ''}</td>
      <td
        className={`summary-status ${getAssetStatusClassName(row.status)}`}
        title={row.status || ''}
      >
        <p className="status-text">{row.status || ''}</p>
      </td>
      <td className="summary-gateway-status">
        {row.gatewayDeviceId ? (
          <button type="button" className="content-link" onClick={() => onGatewayStatusClick(row)}>
            {gatewayLabel}
          </button>
        ) : (
          <span>N/A</span>
        )}
      </td>
      <td className="summary-alertss">
        <SummaryAlertsCell
          row={row}
          onAlertsClick={onAlertsClick}
          badgeClassName={variant === 'pinned' ? 'summary-alertss' : ''}
        />
      </td>
      <td className="text-wrap" title={formatLastCommunication(row.lastCommunication)}>
        {formatLastCommunication(row.lastCommunication)}
      </td>
      <td className="text-wrap" title={formatFirstCommunication(row.firstCommunication)}>
        {formatFirstCommunication(row.firstCommunication)}
      </td>
    </tr>
  );
};

export default SummaryTableRow;
